import PropTypes from 'prop-types'
import React from 'react'
import { FormattedNumber } from 'react-intl'

import { sendHoverSoundCommand } from 'react-wot-bootstrap/lib/helpers/web_to_client'

import Item from '../Item/Item.jsx'
import { StorageTooltip } from './StorageTooltip.jsx'

import { INDUSTRIAL_RESOURCE_DETAILS } from './constants.jsx'

import styles from './Storage.scss'

export const Storage = ({ industrialResource = 0, handleClick, selected }) => {
    return (
        <div>
            <Item
                title={
                    <span className={industrialResource < 0 ? styles.negative : null}>
                        <FormattedNumber value={industrialResource} />
                    </span>
                }
                contents={INDUSTRIAL_RESOURCE_DETAILS}
                type='industrial'
                tooltipId={StorageTooltip.id}
                handleClick={selected ? null : handleClick}
                handleHover={selected ? null : sendHoverSoundCommand}
                selected={selected}
            />
            <StorageTooltip industrialResource={industrialResource} />
        </div>
    )
}

Storage.propTypes = {
    industrialResource: PropTypes.number,
    handleClick: PropTypes.func,
    selected: PropTypes.bool,
}

export default Storage



// WEBPACK FOOTER //
// ./containers/ClanPanel/components/Storage/Storage.jsx